export function formatTimestamp(timestamp) {
  const date = new Date(timestamp);
  const pad = (n) => n.toString().padStart(2, '0');

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());

  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export function getElapsedSecondsSinceIso(isoString) {
  const timestamp = new Date(isoString).getTime();
  const now = Date.now();
  const elapsedMs = now - timestamp;
  return Math.floor(elapsedMs / 1000);
}